/** The desktop campaign table: campaign, discount, starts, ends, status. */
import type { CampaignListRow } from '../ticket-sales-campaigns-list-model';

import { TicketSalesCampaignsTableRow } from './TicketSalesCampaignsTableRow';

export interface TicketSalesCampaignsTableProps {
  rows: readonly CampaignListRow[];
  now: Date;
  /** Whether a row opens the campaign; false for staff who may not edit one. */
  canOpen: boolean;
}

export function TicketSalesCampaignsTable({ rows, now, canOpen }: TicketSalesCampaignsTableProps) {
  return (
    <table className="nb-tbl" aria-label="Campaigns" style={{ minWidth: 760 }}>
      <thead>
        <tr>
          <th scope="col" style={{ paddingLeft: 18 }}>
            Campaign
          </th>
          <th scope="col">Discount</th>
          <th scope="col">Starts</th>
          <th scope="col">Ends</th>
          <th scope="col" style={{ paddingRight: 18 }}>
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <TicketSalesCampaignsTableRow
            key={row.campaign.id}
            row={row}
            now={now}
            canOpen={canOpen}
          />
        ))}
      </tbody>
    </table>
  );
}
